import { createStore, combineReducers, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import refund from './reducer/RefundReducer';
import Ui from './reducer/UiReducer';
import mobile from './reducer/MobileReucer';
import alert from "./reducer/alertReducer";
import sign from "./reducer/signPageReducer";


const rootReducer = combineReducers({
    REFUND: refund,
    UI: Ui,
    MOBILE: mobile,
    ALERT: alert,
    SIGN : sign
})

let composeEnhancers = compose

const configurStore = () => {
    return createStore(rootReducer, composeEnhancers(applyMiddleware(thunk)))
}

export default configurStore